import React from 'react';
import PropTypes from 'prop-types';

const ParishInfo = ({ backgroundImageUrl, fullName, address }) => {
  return (
    <div
      className="wrapper text-white info px-lg-5 d-flex align-items-center flex-shrink-0"
      style={{
        backgroundImage: `url(${backgroundImageUrl})`,
      }}
    >
      <div className="bg-color" />
      <div className="container-lg px-lg-0 pt-5 pb-5 py-lg-0 mx-0">
        <div className="row">
          <div className="col parish-info">
            <h1 className="el-h4">Składam darowiznę</h1>
            <h3 className="h6 mt-5 mb-lg-3">dla</h3>
            <h2 className="el-h4">
              <strong>{fullName}</strong>
            </h2>
            <h3 className="h6 mt-5 mb-lg-3">adres</h3>
            <h4 className="el-h4 address-block">
              {address.lines[0].line}
              <br />
              {address.postal_code} {address.city}
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
};

ParishInfo.propTypes = {
  backgroundImageUrl: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  address: PropTypes.shape({
    lines: PropTypes.arrayOf(
      PropTypes.shape({
        line: PropTypes.string.isRequired,
      }),
    ),
    postal_code: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
  }),
};

export default ParishInfo;
